import type { ReactNode } from 'react';

import styles from './KaiCoachSectionHead.module.css';

interface KaiCoachSectionHeadProps {
  align?: 'center' | 'start';
  /** The heading's id, for the section's aria-labelledby. */
  id: string;
  kicker: string;
  lead?: ReactNode;
  title: ReactNode;
  /** `dark` on navy sections. */
  tone?: 'dark' | 'light';
}

function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ');
}

/** The kicker, h2 and lead that open each Kai Coach page section. */
export function KaiCoachSectionHead({
  align = 'start',
  id,
  kicker,
  lead,
  title,
  tone = 'light',
}: KaiCoachSectionHeadProps) {
  return (
    <div
      className={classNames(
        styles.head,
        tone === 'dark' && styles.dark,
        align === 'center' && styles.center,
      )}
    >
      <p className={styles.kicker}>{kicker}</p>
      <h2 className={styles.title} id={id}>
        {title}
      </h2>
      {lead ? <p className={styles.lead}>{lead}</p> : null}
    </div>
  );
}
